<div class="row">
    <div class="col-md-6">
        <!--Card-->
        <div class="card card-cascade narrower mt-5">

            <!--Card image-->
            <div class="view gradient-card-header blue darken-2 ">
                <h4 class="h4-responsive text-white">Regular map</h4>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body text-center">
                <agm-map [latitude]="map.lat" [longitude]="map.lng" [mapTypeId]="'roadmap'" style="height: 300px">
                    <agm-marker [latitude]="map.lat" [longitude]="map.lng"></agm-marker>
                </agm-map>

            </div>
            <!--/.Card content-->
        </div>
        <!--/.Card-->
    </div>
    <div class="col-md-6">
        <!--Card-->
        <div class="card card-cascade narrower mt-5">

            <!--Card image-->
            <div class="view gradient-card-header  blue darken-2">
                <h4 class="h4-responsive text-white">Hybrid map</h4>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body text-center">
                <agm-map [latitude]="map.lat" [longitude]="map.lng" [mapTypeId]="'hybrid'" style="height: 300px">
                    <agm-marker [latitude]="map.lat" [longitude]="map.lng"></agm-marker>
                </agm-map>

            </div>
            <!--/.Card content-->
        </div>
        <!--/.Card-->
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <!--Card-->
        <div class="card card-cascade narrower mt-5">

            <!--Card image-->
            <div class="view gradient-card-header  blue darken-2">
                <h4 class="h4-responsive text-white">Satelite map</h4>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body text-center">
                <agm-map [latitude]="map.lat" [longitude]="map.lng" [mapTypeId]="'satellite'" style="height: 300px">
                    <agm-marker [latitude]="map.lat" [longitude]="map.lng"></agm-marker>
                </agm-map>

            </div>
            <!--/.Card content-->
        </div>
        <!--/.Card-->
    </div>
    <div class="col-md-6">
        <!--Card-->
        <div class="card card-cascade narrower mt-5">

            <!--Card image-->
            <div class="view gradient-card-header  blue darken-2">
                <h4 class="h4-responsive text-white">Terrains map</h4>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body text-center">
                <agm-map [latitude]="map.lat" [longitude]="map.lng" [mapTypeId]="'terrain'" style="height: 300px">
                    <agm-marker [latitude]="map.lat" [longitude]="map.lng"></agm-marker>
                </agm-map>

            </div>
            <!--/.Card content-->
        </div>
        <!--/.Card-->
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-md-10">
        <!--Section: Docs link-->
        <section class="pb-4 pt-5">
            <panel header="Full documentation" color="primary-color">
                <p class="card-text">Read the full documentation for these components.</p>
                <a href="https://mdbootstrap.com/angular/components/maps/" target="_blank" class="btn btn-primary waves-effect waves-light">Learn more</a>
            </panel>
        </section>
        <!--/.Section: Docs link-->
    </div>
</div>
